module.exports = __webpack_public_path__ + "dist/solution_3.55b2b778.png";